module.exports = __webpack_public_path__ + "static/media/ge.475d3b9c.svg";